/**
 * Data layer for `event-match-quality-emq-improvement-via-server-sid`. Thin typed fetch wrappers over /api/v1/event-match-quality-emq-improvement-via-server-sid.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface EventMatchQualityEmqImprovementViaServerSidRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListEventMatchQualityEmqImprovementViaServerSidResponse {
	count: number;
	items: EventMatchQualityEmqImprovementViaServerSidRow[];
}

export interface CreateEventMatchQualityEmqImprovementViaServerSidBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/event-match-quality-emq-improvement-via-server-sid";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListEventMatchQualityEmqImprovementViaServerSidResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListEventMatchQualityEmqImprovementViaServerSidResponse>(res);
}

export async function create(body: CreateEventMatchQualityEmqImprovementViaServerSidBody): Promise<EventMatchQualityEmqImprovementViaServerSidRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<EventMatchQualityEmqImprovementViaServerSidRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const eventMatchQualityEmqImprovementViaServerSidQueryKeys = {
	all: ["event-match-quality-emq-improvement-via-server-sid"] as const,
	list: () => [...eventMatchQualityEmqImprovementViaServerSidQueryKeys.all] as const,
	detail: (id: string) => [...eventMatchQualityEmqImprovementViaServerSidQueryKeys.all, id] as const,
};
